import React from 'react';

import { SVGComponentProps } from './svg.types';

const DrawSVG = ({
  fill = '#627FE5',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block  ${wrapperClass || ''}`}>
      <svg
        width={33}
        height={45}
        viewBox="0 0 33 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.93328 34.8782L10.0039 38.5498C10.0039 38.5498 7.00748 43.347 5.03319 42.0978C3.05889 40.8485 3.09628 36.8094 4.93328 34.8782Z"
          fill="#EEF1FC"
        />
        <path
          d="M21.5991 7.45898L26.2547 10.7402L20.3229 20.983L10.0041 38.5498L4.9334 34.8783L21.5991 7.45898Z"
          fill={fill}
        />
        <path
          d="M10.6776 39.1932C13.7559 33.8561 16.8346 28.5162 19.9136 23.1732C21.4337 20.5374 22.9528 17.9025 24.4707 15.2684C25.2202 13.9693 25.9715 12.6698 26.7188 11.3693C26.7213 11.3641 26.7244 11.3593 26.7281 11.3549C26.8282 11.3345 26.9186 11.2809 26.9846 11.2028C27.0507 11.1246 27.0885 11.0264 27.092 10.9243C27.433 8.0725 27.9125 5.27086 28.5304 2.51935C28.5612 2.35028 28.5338 2.17601 28.4527 2.02505C28.3716 1.8741 28.2417 1.75538 28.0843 1.68832C27.8376 1.56164 27.559 1.51016 27.2829 1.54022C27.0067 1.57028 26.7451 1.68057 26.5301 1.8575C25.9045 2.32321 25.3489 2.89365 24.782 3.41132C23.6266 4.47041 22.518 5.5707 21.4316 6.69473C21.34 6.69721 21.2507 6.72444 21.1731 6.77352C21.0955 6.8226 21.0324 6.89172 20.9907 6.97358C20.9489 7.05543 20.9299 7.14699 20.9357 7.23857C20.9415 7.33015 20.9718 7.41835 21.0236 7.49386C16.8199 14.2275 12.6159 20.9593 8.41145 27.6892C7.04031 29.8845 5.66941 32.0793 4.29875 34.2739C4.13856 34.522 4.19499 34.8896 4.52117 35.1394L9.79506 39.198C10.0649 39.4067 10.5285 39.4532 10.6776 39.1932ZM24.0761 5.99571L24.0993 6.01065C24.7765 6.37244 25.4383 6.76042 26.0861 7.1848C26.1428 7.22226 26.2036 7.25309 26.2674 7.27669C26.1354 8.10803 26.0107 8.94254 25.901 9.78044C24.7822 9.04995 23.6931 8.27426 22.6338 7.45339C23.1068 6.95935 23.5876 6.47346 24.0761 5.99571ZM5.69602 34.6673C10.4388 27.0711 15.1827 19.4762 19.9279 11.8826C20.6492 10.7264 21.3709 9.57047 22.0929 8.41476C23.1861 9.25746 24.3113 10.0523 25.4684 10.7991C25.1555 11.3395 24.8272 11.87 24.5172 12.4059L22.4521 15.99C19.7165 20.7332 16.9821 25.4762 14.2489 30.2188C12.7821 32.7656 11.3141 35.3127 9.84481 37.86L5.69602 34.6673Z"
          fill="#131720"
        />
        <path d="M26.9999 3L24 6L25 6.5L26.5 7.5L26.9999 3Z" fill={fill || '#254DDA'} />
        <path
          d="M10.5154 38.9898C10.8973 38.3982 9.70074 37.6793 9.31889 38.2709C8.69819 39.2325 8.15031 40.3887 7.24048 41.1182C6.59517 41.6339 5.27314 41.9419 4.45308 40.981C3.70407 40.1036 3.95687 38.8794 4.13671 38.0538C4.37537 36.9805 4.81986 35.9631 5.44545 35.0582C5.84093 34.4769 4.64513 33.7569 4.24894 34.3392C3.42973 35.539 2.9076 36.9163 2.72602 38.3564C2.57716 39.5551 2.7628 41.0561 4.01063 42.0561C5.10819 42.9356 6.58583 42.9964 7.57142 42.5198C9.00235 41.8301 9.71339 40.2299 10.5154 38.9898Z"
          fill="#131720"
        />
      </svg>
    </span>
  );
};

export default DrawSVG;
